import { render, staticRenderFns } from "./MachineProductList.vue?vue&type=template&id=3a806dc8&scoped=true"
import script from "./MachineProductList.vue?vue&type=script&lang=js"
export * from "./MachineProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a806dc8",
  null
  
)

export default component.exports